import styled, { css } from 'styled-components';
import { radius, Box, Group, Skeleton } from '@landr/maestro';
import CommonArtworkUi from 'components/CommonUi/Artwork/Artwork';

const MainImageWidth = 58;
const MainRectangleImageWidth = 72;
const BackgroundImageGap = 16;
const BackgroundRectangleImageGap = 33;
const BackgroundImageWidth = (100 - BackgroundImageGap) / 2;

export const ArtworksWrapper = styled(Group.Item)`
    text-align: center;
    position: relative;
    width: 100%;
    user-select: none;
`;

export const BackgroundWrapper = styled(Group)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    opacity: 24%;
    justify-content: center;
    gap: ${BackgroundImageGap}%;
    align-items: center;
`;

const ImageContainer = css`
    position: relative;
    border-radius: ${radius('lg')};
    overflow: hidden;
`;

export const MainImage = styled(Box)<{ isRectangle?: boolean }>`
    position: relative;
    margin: 0 auto;
    width: ${MainImageWidth}%;
    padding-top: ${MainImageWidth}%;
    filter: drop-shadow(0px 16px 24px rgba(0, 0, 0, 0.24));
    ${({ isRectangle }) =>
        isRectangle &&
        css`
            width: ${MainRectangleImageWidth}%;
        `};
    ${ImageContainer}
`;

export const Left = styled(Group.Item)<{ isRectangle?: boolean }>`
    display: flex-item;
    flex-grow: 1;
    text-align: right;
    padding-bottom: ${BackgroundImageWidth}%;
    ${({ isRectangle }) =>
        isRectangle &&
        css`
            padding-bottom: ${BackgroundRectangleImageGap}%;
        `};
    ${ImageContainer}
`;

export const Right = styled(Group.Item)<{ isRectangle?: boolean }>`
    display: flex-item;
    flex-grow: 1;
    padding-bottom: ${BackgroundImageWidth}%;
    ${({ isRectangle }) =>
        isRectangle &&
        css`
            padding-bottom: ${BackgroundRectangleImageGap}%;
        `};
    ${ImageContainer}
`;

export const ImageSkeleton = styled(Skeleton)`
    position: absolute;
    width: 100%;
    padding-bottom: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const ArtworkWrapper = styled(Box)`
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const Artwork = styled(CommonArtworkUi)`
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 100%;
    object-fit: cover;
`;
